import styled from 'styled-components'

export const EstimatePanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-left: 1px solid ${({ theme }) => theme.colors.border.default};

  ${({ theme }) => theme.breakpoints?.tablet} {
    border-left: none;
    border-top: 1px solid ${({ theme }) => theme.colors.border.default};
  }
`

export const MapSection = styled.div`
  position: relative;
  height: 200px;
  min-height: 200px;
  flex-shrink: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
`

export const StatsSection = styled.div`
  flex: 1;
  min-height: 0;
  padding: ${({ theme }) => theme.spacing.medium};
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.background.primary};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border.default};
    border-radius: ${({ theme }) => theme.borderRadius.small};

    &:hover {
      background: ${({ theme }) => theme.colors.text.tertiary};
    }
  }
`

export const StatsTitle = styled.h4`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.small} 0;
`

export const StepCard = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.medium};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const StepCardHighlighted = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.medium};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: #fff8e1;
  border: 1px solid #ffe082;
`

export const StepNumber = styled.div<{ $highlighted?: boolean }>`
  width: 24px;
  height: 24px;
  min-width: 24px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $highlighted }) => ($highlighted ? '#ffe082' : '#e5e7eb')};
  font-size: ${({ theme }) => theme.typography.fontSize.label};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
`

export const StepTitle = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const StepDescription = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.label};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const RangeContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.medium};
`

export const RangeLabel = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.label};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
`

export const DotStripContainer = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
`

export const DotStripLegend = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  margin-top: ${({ theme }) => theme.spacing.xsmall};
  font-size: ${({ theme }) => theme.typography.fontSize.label};
  color: ${({ theme }) => theme.colors.text.tertiary};
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
`

export const LegendDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: #00ade6;
  opacity: 0.4;
`

export const LegendLine = styled.div<{ $color: string; $dashed?: boolean }>`
  width: 14px;
  height: 2px;
  background: ${({ $color }) => $color};
  ${({ $dashed }) =>
    $dashed
      ? 'background: repeating-linear-gradient(to right, currentColor 0, currentColor 3px, transparent 3px, transparent 5px);'
      : ''}
  color: ${({ $color }) => $color};
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.huge};
  height: 100%;
  border-left: 1px solid ${({ theme }) => theme.colors.border.default};

  ${({ theme }) => theme.breakpoints?.tablet} {
    border-left: none;
    border-top: 1px solid ${({ theme }) => theme.colors.border.default};
  }
`

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.huge};
  color: ${({ theme }) => theme.colors.text.tertiary};
  height: 100%;
  border-left: 1px solid ${({ theme }) => theme.colors.border.default};
  text-align: center;
  gap: ${({ theme }) => theme.spacing.default};

  ${({ theme }) => theme.breakpoints?.tablet} {
    border-left: none;
    border-top: 1px solid ${({ theme }) => theme.colors.border.default};
  }
`
